// Copyright (c) Ensho Health, 2021 to present

import * as user from './user.api.js';
import * as heartbeat from './heartbeat.api.js';
import * as notification from './notification.api.js';
import * as encryption from './encryption.api.js';
import * as clinic from './clinic.api.js';
import * as labResult from './lab-result.api.js';
import * as patient from './patient.api.js';
import * as order from './order.api.js';
import * as cdlServices from './cdl-services.api.js';

const api = {
  cdlServices,
  clinic,
  encryption,
  heartbeat,
  labResult,
  notification,
  order,
  patient,
  user
};
export default api;
